import {
  ColDef,
  EditableCallbackParams,
  CellClassParams,
  ValueSetterParams,
  ICellRendererParams,
} from 'ag-grid-community'
import { ClientSideSelectFilter } from '../../../../containers/BulkSheetView/components/filter'
import { propertyType } from '../../../../page-properties/bulksheet-properties/wbsItemAdditionalProperty'
import {
  isAdditionalPropertyRow,
  isGroupHeaderRow,
  AdditionalPropertyRow,
  WbsItemAdditionalPropertyRow,
} from '../../rowModel/wbsItemAdditionalPropertyRow'
import { DISABLE_COLOR } from './style'
import { SelectCellEditor } from '../../../../containers/BulkSheetView/components/cellEditor'
import {
  propertyTypeIsChangeable,
  shouldHaveSelectOptions,
  WbsItemAdditionalPropertyType,
} from '../../../../../domain/entity/WbsItemAdditionalPropertyEntity'
import store from '../../../../../store'
import { requireSave } from '../../../../../store/requiredSaveData'
import { intl } from '../../../../../i18n'

export const propertyTypeColumnDef: ColDef = {
  ...propertyType,
  editable: (params: EditableCallbackParams<WbsItemAdditionalPropertyRow>) => {
    return Boolean(
      params.node.data &&
        isAdditionalPropertyRow(params.node.data) &&
        propertyTypeIsChangeable(params.node.data as AdditionalPropertyRow)
    )
  },
  cellStyle: (params: CellClassParams) =>
    isGroupHeaderRow(params.node.data)
      ? {
          backgroundColor: DISABLE_COLOR,
        }
      : undefined,
  valueSetter: ({
    oldValue,
    newValue,
    data,
    node,
    api,
  }: ValueSetterParams<AdditionalPropertyRow>) => {
    if (!node || oldValue === newValue) {
      return false
    }
    data.edited = true
    data.propertyType = newValue
    if (shouldHaveSelectOptions(oldValue)) {
      data.selectOptions = undefined
    }
    if (shouldHaveSelectOptions(newValue)) {
      data.selectOptions = []
    }
    if (
      shouldHaveSelectOptions(oldValue) ||
      shouldHaveSelectOptions(newValue)
    ) {
      // To refresh cell style.
      // Use redrawRows because validation is not executed when using refreshCells.
      api.redrawRows({
        rowNodes: [node],
      })
    }

    if (WbsItemAdditionalPropertyType.ENTITY_SEARCH === oldValue) {
      data.entitySearchReferenceEntityType = undefined
      data.entitySearchReferenceEntityWbsItemType = undefined
    }
    if (
      WbsItemAdditionalPropertyType.ENTITY_SEARCH === oldValue ||
      WbsItemAdditionalPropertyType.ENTITY_SEARCH === newValue
    ) {
      // To refresh cell style.
      // Use redrawRows because validation is not executed when using refreshCells.
      api.redrawRows({
        rowNodes: [node],
      })
    }

    store.dispatch(requireSave())
    return true
  },
  cellRendererParams: {
    validate: (
      value: WbsItemAdditionalPropertyType | undefined,
      params: ICellRendererParams
    ): string | undefined => {
      if (!isAdditionalPropertyRow(params.data)) return
      if (!value) {
        return intl.formatMessage({
          id: 'boolExpression.requiredField',
        })
      }
      return undefined
    },
    tooltip: (params: ICellRendererParams<WbsItemAdditionalPropertyRow>) => {
      if (
        params.node.data &&
        isAdditionalPropertyRow(params.node.data) &&
        !propertyTypeIsChangeable(params.node.data as AdditionalPropertyRow)
      ) {
        return intl.formatMessage({
          id: 'wbsItemAdditionalProperties.tooltip.usingProperty.canot.change',
        })
      }
      return undefined
    },
  },
  cellEditor: SelectCellEditor,
  cellEditorParams: {
    options: Object.keys(WbsItemAdditionalPropertyType).map(key => ({
      label: key,
      value: WbsItemAdditionalPropertyType[key],
    })),
  },
  filter: ClientSideSelectFilter,
  floatingFilter: true,
  filterParams: {
    valueGetter: (params: { node; context }) => {
      if (!params.node || isGroupHeaderRow(params.node.data)) {
        return undefined
      }
      const additionalPropertyRow = params.node.data as AdditionalPropertyRow
      return additionalPropertyRow.propertyType
    },
    getValue: o => o,
    getLabel: o => o,
    filterChangedCallback: () => {
      return
    },
  },
}
